import './WizardActions.scss';

import React, { FC } from 'react';
import { Nav } from 'react-bootstrap';

import { WizardStepInfo } from '../SetupWizard/WizardStepInfo';

const WizardActions: FC<WizardStepInfo> = ({
  nextStep,
  previousStep,
  goToStep,
  totalSteps,
  step,
  onFormValidated,
}) => {
  const validateAndNext = (event: any) => {
    const { form } = event.currentTarget;
    const isValid = form.checkValidity();
    if (!isValid) {
      event.preventDefault();
      event.stopPropagation();
    }
    // eslint-disable-next-line no-undef-init
    let validationGoToStepNumber: number | void = undefined;
    if (onFormValidated) {
      validationGoToStepNumber = onFormValidated(true);
    }
    if (isValid) {
      if (validationGoToStepNumber) {
        goToStep(validationGoToStepNumber);
      } else {
        nextStep(event);
      }
    }
  };

  return (
    <div className="wizard-actions">
      <Nav>
        {step > 1 && (
          <Nav.Item>
            <button type="button" className="btn btn-secondary btn-block" id={`wizardPreviousBtn_${step}`} onClick={previousStep}>
              Previous
            </button>
          </Nav.Item>
        )}
        {step < totalSteps! ? (
          <Nav.Item className="ml-2">
            <button type="button" className="btn btn-primary btn-block" id={`wizardNextBtn_${step}`} onClick={validateAndNext}>
              Next
            </button>
          </Nav.Item>
        ) : (
          <Nav.Item className="ml-2">
            <button type="button" className="btn btn-success btn-block" id="wizardFinishBtn" onClick={validateAndNext}>
              Finish
            </button>
          </Nav.Item>
        )}
      </Nav>
    </div>
  );
};

export default WizardActions;
